import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const LyricSeparator = makeShortcode("LyricSeparator");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`過ぎし日よ、さようなら`}</h1>
    <div style={{
      padding: 16,
      margin: 8,
      border: '1px solid orange'
    }}>
  こちらのコンテンツは新しいサイトに移行しています。以下のリンクから新サイトをご覧ください。
  <div style={{
        margin: 16,
        textAlign: "center",
        overflowWrap: "break-word"
      }}>
    <a href="https://capriccioso.info/opera/la-traviata/addio-del-passato">https://capriccioso.info/opera/la-traviata/addio-del-passato</a>
  </div>
    </div>
    <h4>{`Addio, del passato bei sogni ridenti`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`La traviata – Addio, del passato (Ermonela Jaho, The Royal Opera)`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/Do4Ei7Cio2g" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Anna Netrebko, La Traviata: Addio del passato (French subtitles)`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/cSr7hh9mbyg" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <p>
  <Ex m="さようなら" mdxType="Ex">Addio</Ex>, <Ex m="di + il" mdxType="Ex">del</Ex> <Ex m="過去" mdxType="Ex">passato</Ex> <Ex m="美しい" o="bello" mdxType="Ex">bei</Ex> <Ex m="夢" o="sogno" mdxType="Ex">sogni</Ex> <Ex m="うれしそうな、心地よい" o="ridente" mdxType="Ex">ridenti</Ex>
    </p>
    <Tr mdxType="Tr">さようなら、過ぎし日の美しく楽しい夢よ</Tr>
    <p>
  <Ex m="バラ、バラ色、ピンク" o="rosa" mdxType="Ex">Le rose</Ex> del <Ex m="顔つき、顔色" mdxType="Ex">volto</Ex> <Ex m="すでに、もう" mdxType="Ex">già</Ex> <Ex m="〜である（英語のbe動詞）" o="essere" mdxType="Ex">sono</Ex> <Ex m="青白い（詩語; = pallido）" o="pallente" mdxType="Ex">pallenti</Ex>;
    </p>
    <Tr mdxType="Tr">頬のバラ色ももう青ざめてしまった</Tr>
    <p>
  <Ex m="愛" mdxType="Ex">l'amore</Ex> d'Alfredo <Ex m="〜でさえも" mdxType="Ex">perfino</Ex> <Ex m="私に" mdxType="Ex">mi</Ex> <Ex m="不足する、欠ける" mdxType="Ex">manca</Ex>,
    </p>
    <Tr mdxType="Tr">アルフレードの愛さえも私にはない</Tr>
    <p>
  <Ex m="慰め、心の支え" mdxType="Ex">conforto</Ex>, <Ex m="支え、たより" mdxType="Ex">sostegno</Ex> <Ex m="di + l'" mdxType="Ex">dell'</Ex><Ex m="魂" mdxType="Ex">anima</Ex> <Ex m="疲れた" mdxType="Ex">stanca</Ex>
    </p>
    <Tr mdxType="Tr">疲れた魂の慰めであり、支えなのに</Tr>
    <p>
  conforto, sostegno, ah!
    </p>
    <Tr mdxType="Tr">慰め、支え、ああ！</Tr>
    <p>
  della <Ex m="道を踏み外した（定冠詞 + 形容詞で「〜な人」ここでは女性形なので「道を踏み外した女」。原題はここから採られている）" o="traviato" mdxType="Ex">traviata</Ex> <Ex m="ほほえむ" o="sorridere" mdxType="Ex">sorridi</Ex> <Ex m="a + il" mdxType="Ex">al</Ex> <Ex m="願い (= desiderio)" mdxType="Ex">desio</Ex>,
    </p>
    <Tr mdxType="Tr">道を踏み外した女の願いにほほえんでください</Tr>
    <p>
  a <Ex m="彼女" mdxType="Ex">lei</Ex>, <Ex m="お願いだから（間投詞、文語）" mdxType="Ex">deh</Ex>, <Ex m="許す" o="perdonare（この動詞は他動詞としても使われるが、ここでは自動詞。perdonare a leiで「彼女に対して容赦する」）" mdxType="Ex">perdona</Ex>, <Ex m="君は、あなたは（二人称単数の主語。ここでは「神」）" mdxType="Ex">tu</Ex> <Ex m="迎える、受け入れる（語末のlaは「彼女を」）" o="accogliere" mdxType="Ex">accoglila</Ex>, o Dio!
    </p>
    <Tr mdxType="Tr">お願いですから、彼女をお許しください、彼女を受け入れてください、おお、神よ！</Tr>
    <p>
  Ah! <Ex m="すべて" mdxType="Ex">tutto</Ex>, tutto <Ex m="終わる（遠過去）" mdxType="Ex">finì</Ex>, <Ex m="今 (= ora)" mdxType="Ex">or</Ex> tutto, tutto finì
    </p>
    <Tr mdxType="Tr">ああ！ 今やすべては終わってしまったのです</Tr>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  <Ex m="喜び（綴りにjを使うのは古い書き方で、今ではiを使う）" o="gioia" mdxType="Ex">Le gioje</Ex>, <Ex m="苦痛" mdxType="Ex">i dolori</Ex> <Ex m="今から〜後に" mdxType="Ex">tra</Ex> <Ex m="少しの（時間）" mdxType="Ex">poco</Ex> <Ex m="avere の未来形・3人称複数 avranno の語尾が切断された形（トロンカメント）" o="avere" mdxType="Ex">avran</Ex> <Ex m="終わり" mdxType="Ex">fine</Ex>;
    </p>
    <Tr mdxType="Tr">喜びも苦しみも、もうすぐ終わりをむかえるでしょう</Tr>
    <p>
  <Ex m="墓" mdxType="Ex">la tomba</Ex> <Ex m="a + i" mdxType="Ex">ai</Ex> <Ex m="（死すべきものとしての）人間" mdxType="Ex">mortali</Ex> di <Ex m="すべて" mdxType="Ex">tutto</Ex> <Ex m="〜である（英語のbe動詞）" mdxType="Ex">è</Ex> <Ex m="境界、果て" mdxType="Ex">confine</Ex>!
    </p>
    <Tr mdxType="Tr">死すべき定めである人間にとって、墓はすべての最果てです</Tr>
    <p>
  Non <Ex m="涙 (= lacrima)" mdxType="Ex">lagrima</Ex> <Ex m="または（英語のor）" mdxType="Ex">o</Ex> <Ex m="花" mdxType="Ex">fiore</Ex> <Ex m="持つ（未来）（英語のhave）" o="avere" mdxType="Ex">avrà</Ex> la <Ex m="私の" mdxType="Ex">mia</Ex> <Ex m="穴、墓穴" mdxType="Ex">fossa</Ex>!
    </p>
    <Tr mdxType="Tr">私の墓には涙もお花もささげられないでしょう</Tr>
    <p>
  non <Ex m="十字架" mdxType="Ex">croce</Ex> <Ex m="con（〜と一緒に、〜付きの） + il" mdxType="Ex">col</Ex> <Ex m="名前" mdxType="Ex">nome</Ex> <Ex m="関係代名詞（英語のthat, which）" mdxType="Ex">che</Ex> <Ex m="覆う" o="coprire" mdxType="Ex">copra</Ex> <Ex m="この" mdxType="Ex">quest'</Ex><Ex m="骨" o="osso" mdxType="Ex">ossa</Ex>!
    </p>
    <Tr mdxType="Tr">この骨を覆う名前を刻んだ十字架もないでしょう</Tr>
    <p>
  non croce, non fior, ah!
    </p>
    <Tr mdxType="Tr">十字架も、お花も、ああ！</Tr>
    <p>
  della traviata sorridi al desio,
    </p>
    <Tr mdxType="Tr">道を踏み外した女の願いにほほえんでください</Tr>
    <p>
  a lei, deh, perdona, tu accoglila, o Dio!
    </p>
    <Tr mdxType="Tr">お願いですから、彼女をお許しください、彼女を受け入れてください、おお、神よ！</Tr>
    <p>
  Ah! tutto, tutto finì, or tutto, tutto finì
    </p>
    <Tr mdxType="Tr">ああ！ 今やすべては終わってしまったのです</Tr>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/71578a786f95c8e590a11e4f10fabeb4/8698d/traviata-addio-del-passato.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "152.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAYAAADnTu3OAAAACXBIWXMAABcSAAAXEgFnn9JSAAADkklEQVRIx6XV12okMRAF0P7/v7HBGOMxzuOIs8c555xz0HJqqaEx7O7DCtSSSlKFe6vUVfmP9v39XT4+PqK/v7+Xr6+vUvm8vb3F5uvra3l8fCwPDw8h0z4/P2MvZXn55eUl9m9vb8vFxUXsk1cEjUajrK6ulrm5udLX11cmJibKzMxMGRwcLAsLC2V+fr50dHTEODs7G93c2ZWVlTjT398fysNDmi148PT0VO7v76NvbGyE9Zubm9h7fn4OT0ThHGXm7i4uLkY0lY39/f1ydnYWB0ZHR2O+t7cX4+7ubjk+Po61KLa3t8vy8nLcOT8/LycnJ+Xw8LDs7OyEsYqFtbW1OCjMpaWlONRqtcrBwUG5vLwMhbpLdSOUkoni9PQ0vK4AK5y7u7sISRcCGMgQhYAkQ1hJChnIzN1BXnV9fV2mpqbK+vp6gMszgPMa+MLJcAcGBmJ/c3MzZCICES/JGA9SWEoyWOEl78yzkbl4dXUVHmrmQgUb4sJDira2tgLDo6OjsOyiOazgZCRz2TlzGIoq7yKI0VCYpExPT0fuUSIne3p6Qpkwx8bGQiEIpBM5mTn8OBAKMxzMUg4CIWSlGF3gETadzbJzHlxIyWqrxD45ORlhSBldklLAqtSxhxBkIUElicS53t7eWKsautqVorHIm7TMon1eZR3bl5swk8iMWYswHgeXCXkCF2NWTiat1MIoGYWwpEDauOMMbANDVgjzURCaUOBIgcPSiSJeIUGJyjssI5Ssq6vrd+kJS/YLKauDjMJsFOZzlXnqDrlzoEgSgxSVwurQ0FCALbdUiUeA3POWT1p3d3dEgDxROcdTIwNV0k8x77jNok3YGXM/08c5ntnPhxUx7gUpMAR0gp3PFHwoSCyTURHkk2Z0h454sVkCsA0MO2ztsgrBOAMuYFIHBWVZegxbwzFC1i28Fj9/QPlkJTQIcY6snqPZ4vkCNrdVhn8DklhlnUcqaXx8PGQIUTHWSRaCkNWuFD0bpfkfySb/8pniHVLqMmQJOSqFywiAEY/SK9hllzowpSSTm4I8l7/RwDD/Xi4Yh4eHI/wkJmXWPErm7QmfM8oSdPFi56uctZpPV/21zrmQkJHz/NFnVbX/KUiBXbPZjA5wY2dnZ/uHPzIyEr2+9pQJm9ci4FAlNfLPxlKOSOE1AuSbi4zCUJjW8lY0vM40qjIsi8zJerj/anmvnYd/UlBX/rf+8/wvoBoH5zyxkqgAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/71578a786f95c8e590a11e4f10fabeb4/5a190/traviata-addio-del-passato.png",
            "srcSet": ["/static/71578a786f95c8e590a11e4f10fabeb4/772e8/traviata-addio-del-passato.png 200w", "/static/71578a786f95c8e590a11e4f10fabeb4/e17e5/traviata-addio-del-passato.png 400w", "/static/71578a786f95c8e590a11e4f10fabeb4/5a190/traviata-addio-del-passato.png 800w", "/static/71578a786f95c8e590a11e4f10fabeb4/c1b63/traviata-addio-del-passato.png 1200w", "/static/71578a786f95c8e590a11e4f10fabeb4/8698d/traviata-addio-del-passato.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      